/** Capture loyalty card DOM → PNG / PDF / share for Wallet. */

export async function cardToCanvas(el: HTMLElement) {
  const { default: html2canvas } = await import('html2canvas');
  return html2canvas(el, {
    backgroundColor: '#ffffff',
    scale: 2,
    useCORS: true,
    logging: false,
  });
}

export function triggerDownload(dataUrl: string, filename: string) {
  const link = document.createElement('a');
  link.download = filename;
  link.href = dataUrl;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function dataUrlToBlob(dataUrl: string): Blob {
  const [header, data] = dataUrl.split(',');
  const mime = /data:([^;]+)/.exec(header)?.[1] || 'image/png';
  const binary = atob(data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

export async function downloadCardPdf(el: HTMLElement, fileBase: string) {
  const canvas = await cardToCanvas(el);
  const img = canvas.toDataURL('image/png');
  const { jsPDF } = await import('jspdf');
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [90, 140] });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  pdf.addImage(img, 'PNG', 0, 0, pageW, pageH);
  pdf.save(`${fileBase}.pdf`);
}

export async function downloadCardPng(el: HTMLElement, fileBase: string) {
  const canvas = await cardToCanvas(el);
  triggerDownload(canvas.toDataURL('image/png'), `${fileBase}.png`);
}

export async function addCardToWallet(el: HTMLElement, fileBase: string): Promise<'shared' | 'downloaded'> {
  const canvas = await cardToCanvas(el);
  const dataUrl = canvas.toDataURL('image/png');
  const blob = dataUrlToBlob(dataUrl);
  const file = new File([blob], `${fileBase}.png`, { type: 'image/png' });

  const canShareFiles =
    typeof navigator !== 'undefined' &&
    typeof navigator.share === 'function' &&
    (!navigator.canShare || navigator.canShare({ files: [file] }));

  if (canShareFiles) {
    try {
      await navigator.share({
        files: [file],
        title: 'Loyalty Card',
        text: 'Loyalty member card',
      });
      return 'shared';
    } catch (err) {
      if ((err as Error)?.name === 'AbortError') throw err;
    }
  }

  triggerDownload(dataUrl, `${fileBase}.png`);
  return 'downloaded';
}
